import { openPopup } from './popups';

const cartAddLink = document.querySelector('.cart-add-js');
const headerCartButton = document.querySelector('.header-cart-button');
const headerCartButtonCount = headerCartButton.querySelector('.header-cart-button__count');

if (cartAddLink && headerCartButton && headerCartButtonCount) {
  cartAddLink.addEventListener('click', function (event) {
    event.preventDefault();

    const href = event.target.getAttribute('data-href');

    fetch(href, {
      'headers': {
        'sec-fetch-dest': 'empty',
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'same-origin'
      },
      'method': 'GET',
      'credentials': 'include'
    })
      .then(response => response.json())
      .then(response => {
        if (response.success) {
          const popupUrl = event.target.dataset.popup;
          openPopup(event.target, popupUrl);

          event.target.remove();
          headerCartButton.classList.remove('disabled');

          const currentCount = parseInt(headerCartButtonCount.textContent, 10);
          headerCartButtonCount.textContent = currentCount + 1;

          // document.querySelector('.header-cart-button').click();
        } else {
          console.error('Error adding item to cart:', response.statusText);
        }
      })
      .catch(error => {
        console.error('GET request error:', error);
      });
  });
}
